import React = require("react");
import {mapServerUrl, layerFromMetricPeriod} from './const';
import {connect} from "react-redux";
import {iState} from "./store";
import $ = require("jquery");
import * as cnst from './const';


class _Legend extends React.Component<{ metric: string, period: string },
    { legendInfo: Object }> {

    constructor(p, c) {
        super(p, c);

        this.state = {legendInfo: {}};
    }

    componentDidMount() {
        $.get(mapServerUrl + '/legend',
            {f: 'pjson'},
            (d) => {
                this.setState({legendInfo: d});
            },
            'jsonp');
    }

    render() {
        //
        let legendLis = [];

        if (this.props.metric === cnst.METRICS[0]){
            legendLis.push(<li><b>{cnst.METRICS_LABELS[0]}</b></li>)
        } else if (this.props.metric === cnst.METRICS[1]){
            legendLis.push(<li><b>{cnst.METRICS_LABELS[1]}</b></li>)
        }

        let lyr = layerFromMetricPeriod(
            this.props.metric,
            this.props.period
        );

        if (lyr !== -1 && this.state.legendInfo['layers']) {
            for (let l of this.state.legendInfo['layers'][lyr]['legend']) {
                legendLis.push(
                    <li key={l['label']}>
                        <img src={`data:image/png;base64,${l['imageData']}`}/>
                        <label style={{marginRight: '7px'}}>{l['label']}</label>
                    </li>
                )
            }
        }


        return <ul style={{marginTop: '15px'}} className="legend-ul">
            {legendLis}
        </ul>
    }


}

export const Legend = connect((s: iState) => {
    return {
        metric: s.metric,
        period: s.period
    }
})(_Legend)
